import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

const Container = styled.div`
  margin-bottom: 10px;
`;

const Title = styled.h3`
  margin: 0;
  margin-bottom: 4px;
  padding: 0;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #333333;
  font-weight: bold;
`;

const SelectWrapper = styled.div`
  position: relative;
`;

class Select extends React.Component {

  static propTypes = {
    title: PropTypes.string,
    selectedValue: PropTypes.string,
    options: PropTypes.array,
    isLoading: PropTypes.bool,
    onValueChange: PropTypes.func,
    getValue: PropTypes.func,
    getSelectedValue: PropTypes.func,
    getOptionText: PropTypes.func,
    getOptionHint: PropTypes.func
  }

  renderOptions = () => {
    return this.props.options.map((option) => {
      return (
        { value: this.props.getValue(option), label: this.props.getOptionText(option)}
      );
    });
  }

  render = () => {
    return (
      <Container>
        <Title>{this.props.title}</Title>
        <SelectWrapper>
          <ReactSelect
              isDisabled={this.props.isLoading}
              value={{ value: this.props.selectedValue, label: this.props.getSelectedValue()}}
              onChange={(e) => {
                this.props.onValueChange(e.value);
              }}
              options={this.renderOptions()}
              isSearchable={false}
              menuPlacement={"bottom"}>
          </ReactSelect>
        </SelectWrapper>
      </Container>
    );
  }

}
export default Select;

